import { FC, ReactNode, ComponentProps, Fragment, createElement } from 'react';

type ILoopRenderProps<T = any> = ComponentProps<'div'> & {
    list: T[] | undefined;
    tag?: false | string;
    render: (item: T, renderProps: {
        index: number;
        first: boolean;
        last: boolean;
    }) => ReactNode;
};


export const Main: FC<{ list: any[]; render: ILoopRenderProps['render'] }> = props => {
    const { list, render } = props;
    return (
        <>
            {list.map((item, index) => (
                <Fragment key={index}>
                    {render(item, {
                        index,
                        first: index === 0,
                        last: index === list.length - 1
                    })}
                </Fragment>
            ))}
        </>
    )
};

export const LoopRender: FC<ILoopRenderProps> = props => {
    const { list, render, tag = 'div', ...rest } = props;

    if (!list || list.length === 0) {
        return null;
    }
    if (tag === false) {
        return <Main list={list} render={render}/>;
    }

    return createElement(tag, rest, <Main list={list} render={render}/>);
};
